export const TOP_LEVEL_NAV = {
  REPORTS: "reports",
  MANAGE_ACCOUNTS: "manageAccounts",
  MANAGE_USERS: "manageUsers",
  HELP_TOURS: "helpTours",
  TEMPLATES: "templates",
  CAMPAIGNS: "campaigns",
  MORE: "more",
};

let openTopLevelSection = null;
const topLevelListeners = new Set();

export function isTopLevelNavSectionOpen(sectionId) {
  return openTopLevelSection === sectionId;
}

export function toggleTopLevelNavSection(sectionId) {
  openTopLevelSection = openTopLevelSection === sectionId ? null : sectionId;
  topLevelListeners.forEach((listener) => listener(openTopLevelSection));
}

export function openTopLevelNavSection(sectionId) {
  if (openTopLevelSection === sectionId) {
    return false;
  }
  openTopLevelSection = sectionId;
  topLevelListeners.forEach((listener) => listener(openTopLevelSection));
  return true;
}

export function subscribeTopLevelNavAccordion(listener) {
  topLevelListeners.add(listener);
  return function unsubscribe() {
    topLevelListeners.delete(listener);
  };
}



// WEBPACK FOOTER //
// ./src/components/leftnav/navAccordion.js